// extracted by mini-css-extract-plugin
export default {"main-container":"EcommerceCallback_main-container__bUZcT"};